module.exports = __webpack_public_path__ + "img/5.43e4842c.jpg";